import ttt from '@xing-com/ticktricktrack';

import { TRACKING_COMMENT_INPUT_HINT } from '../../constants/tracking-constants';
import { formatStoryType } from '../formatters';

export type trackLikeProps = (props: {
  hasLike: boolean;
  inputHintClick?: boolean;
  propChannel: string;
  urn: string;
}) => void;

export const trackLike: trackLikeProps = ({
  hasLike,
  inputHintClick = false,
  propChannel = '',
  urn = '',
}) => {
  const storyType = formatStoryType(urn);

  const EventType = hasLike ? 'EventLike' : 'EventUnlike';
  const interactionType = hasLike ? 'social_like' : 'social_unlike';

  ttt.event(EventType, {
    [EventType]: 1,
    PropChannel: propChannel,
    PropInteractionType: `${interactionType}|-|${storyType}`,
    PropSocialObjectId: urn,
    ...(inputHintClick && {
      PropContextDimension3: TRACKING_COMMENT_INPUT_HINT,
    }),
  });
};
